import React, { FC } from 'react'

import * as SC from './styled'

export type FormTextProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string
  name: string
  value?: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  error?: string
  showError?: boolean
  help?: string
}

const FormText: FC<FormTextProps> = (props) => {
  const { className, label, error, showError = true, help, ...inputProps } = props

  return (
    <SC.Container className={className} $isDisabled={inputProps.disabled}>
      {label && <SC.Label required={inputProps.required}>{label}</SC.Label>}
      <SC.Input {...inputProps} $isError={!!error} $isDisabled={inputProps.disabled} />
      {help && <SC.Help>{help}</SC.Help>}
      {error && showError && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormText
